import {api} from './api';
import {techniquesData} from '../data/techniques';

// Bitácora de uso (BI). Nunca debe interrumpir al usuario: los errores se ignoran.
export function track(action,{module='',itemId='',itemName='',details={}}={}) {
  api('/activity',{method: 'POST',body: {action,module,itemId,itemName,details}}).catch(()=> {});
}

// Sección del catálogo (basicos, secuencias, formas...) a la que pertenece una técnica.
const sectionById=Object.fromEntries(
  Object.entries(techniquesData).flatMap(([section,items])=> items.map(item=> [item.id,section]))
);

export function trackTechnique(action,technique,details={}) {
  track(action,{
    module: sectionById[technique.id] || '',
    itemId: technique.id,
    itemName: technique.spanishName || technique.koreanName,
    details: {cinta: technique.beltType,...details},
  });
}
